import React from "react";

const Header_WorkBoq: React.FC = (props: any) => {
  return (
    <>
      <div id="workBoqForms" className="steps clearfix">
        <ul>
          <li className={props.current >= 1 ? "first done" : "first"}>
            <a href="#wizard-01-h-0" onClick={(ev) => ev.preventDefault()}>
              <h5>General Information</h5>
            </a>
          </li>
          <li className={props.current >= 2 ? "done" : ""}>
            <a href="#wizard-01-h-1" onClick={(ev) => ev.preventDefault()}>
              <span className="current-info audible">current step: </span>
              <h5>Work Order Lines</h5>
            </a>
          </li>
          <li className={props.current === 3 ? "last done" : "last"}>
            <a href="#wizard-01-h-2" onClick={(ev) => ev.preventDefault()}>
              <span className="current-info audible">current step: </span>
              <h5>Preview & Submit</h5>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header_WorkBoq;